import classNames from 'classnames';
import ProBadge from 'components/domain/account/ProBadge/ProBadge';
import { ClassName } from 'types/ClassName';
import { useFeatureFlags } from 'utils/features';
import { t } from 'utils/localize';
import DetailsItem, { IDetailsItemProps } from '../DetailsItem';

interface IProDetailsItemProps extends Omit<IDetailsItemProps, 'rightContent'> {
  disabledText?: string;
  showChildrenWhenDisabled?: boolean;
  className?: ClassName;
}

function ProDetailsItem({
  className,
  value,
  disabled,
  disabledText = t('Disabled'),
  children,
  showChildrenWhenDisabled = false,
  ...rest
}: IProDetailsItemProps) {
  const isPro = useFeatureFlags('PRO');
  const classes = classNames('pro-details', className);
  const isDisabled = disabled || !isPro;
  const isEnabled = !isDisabled;

  return (
    <DetailsItem
      className={classes}
      rightContent={<ProBadge />}
      disabled={isDisabled}
      value={isPro ? value : disabledText}
      {...rest}
    >
      {(isEnabled || showChildrenWhenDisabled) && children}
    </DetailsItem>
  );
}

export default ProDetailsItem;
